<template>
  <HomePage></HomePage>
</template>
<script>
import HomePage from "../components/HomePage";

export default {
  name: "Home",

  components: {
    HomePage,
  },
};
</script>
